export * from './player-footer-row.component';
